//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

// TODO: PD-285704: Remove this once tiktok mentions ingestion feature flag is released
export const getTikTokMentionsFeatureEnabled = createHasFeatureSelector(
  FeatureNames.TiktokMentionedMediaIngestion,
);
